export const routes = [
  {
    name: "GETTING STARTED",
    icon: "fas fa-book",
    pages: [["installation","free"], ["license","free"], ["what-is-tailwind-css","free"]],
  },
  {
    name: "Customization",
    icon: "fas fa-paint-brush",
    pages: [["theming","free"], ["colors","free"], ["fonts","free"], ["shadows","free"], ["screens","free"]],
  },
  // {
  //   name: "components",
  //   icon: "fas fa-shapes",
  //   pages: [
  //     "accordion",
  //     "actions",
  //     "alert",
  //     "avatar",
  //     "breadcrumbs",
  //     "button",
  //     "badge",
  //     "calendar",
  //     "card",
  //     "charts",
  //     "checkbox",
  //     "data-display",
  //     "icon-button",
  //     "input",
  //     "kanban",
  //     "map",
  //     "modal",
  //     "menu",
  //     "navbar",
  //     "pin-input",
  //     "popover",
  //     "progress-bar",
  //     "radio-button",
  //     "range-slider",
  //     "select",
  //     "switch", 
  //     "textarea",
  //     "tooltip",
  //     "typography",
  //     "wizard",
  //   ],
  // },
  {
    name: "components",
    icon: "fas fa-shapes",
    pages: [
      ["accordion","free"],
      ["actions","pro"],
      ["alert","free"],
      ["avatar","free"],
      ["breadcrumbs","free"],
      ["button","free"],
      ["badge","free"], 
      ["card","free"], 
      ["checkbox","free"],
      ["data-display","pro"],
      ["icon-button","free"],
      ["input","free"],  
      ["modal","free"],
      ["menu","free"],
      ["popover","free"],
      ["progress-bar","free"],
      ["radio-button","free"], 
      ["select","free"],
      ["switch","free"], 
      ["textarea","free"],
      ["tooltip","free"],
      ["typography","free"], 
    ],
  },
  {
    name: "plugins",
    icon: "fa fa-puzzle-piece",
    pages: [
      ["calendar","pro"],
      ["charts","free"],
      ["data-tables","free"],
      ["dropzone","free"],
      ["kanban","pro"],
      ["map","pro"],
      ["pin-input","pro"],
      ["range-slider","pro"],
      ["wizard","pro"],
    ],
  },
];
